import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Leaf, ArrowRight } from 'lucide-react';
import { HERO_STATS } from '../data/homeData';

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-bg">
        <img
          src="/images/hero-spices.png"
          alt="Overhead view of bowls of heritage spices and cereals"
          className="hero-bg-img"
        />
        <div className="hero-radial" />
        <div className="hero-gradient" />
      </div>

      <div className="hero-glow" />

      <svg className="hero-circle-text" viewBox="0 0 200 200" aria-hidden="true">
        <defs>
          <path
            id="circle-path"
            d="M 100,100 m -78,0 a 78,78 0 1,1 156,0 a 78,78 0 1,1 -156,0"
          />
        </defs>
        <text fill="var(--turmeric)" fontSize="10" letterSpacing="4" className="circle-text">
          <textPath href="#circle-path">
            · INDIA TO UK · WHOLESALE · FSSAI · TAMIL NADU · EXPORT ·
          </textPath>
        </text>
      </svg>

      <div className="hero-inner">
        <div className="reveal hero-badge">
          <span className="badge-line" />
          <Sparkles size={12} />
          India → United Kingdom · Wholesale Import
          <span className="badge-line" />
        </div>

        <h1 className="hero-title">
          <span className="reveal hero-line">Authentic Indian groceries,</span>
          <span className="reveal hero-line hero-italic text-gradient-luxe">delivered to the</span>
          <span className="reveal hero-line">United Kingdom.</span>
        </h1>

        <div className="reveal hero-divider">
          <span className="divider-line" />
          <Leaf size={16} className="divider-leaf" />
          <span className="divider-line" />
        </div>

        <p className="reveal hero-subtitle">
          Swarvinn Impex exports premium rice, spices, pulses, millets, flours, and
          oils from Tamil Nadu to UK wholesalers, cash &amp; carry, supermarkets, and
          food distributors — with private labelling and reliable sea freight.
        </p>

        <div className="reveal hero-ctas">
          <Link to="/products" className="btn-luxe">
            Browse UK Catalogue
            <ArrowRight size={16} />
          </Link>
          <Link to="/contact" className="btn-outline">Request a UK Quote</Link>
        </div>

        <div className="reveal hero-stats">
          {HERO_STATS.map((stat) => (
            <div key={stat.label} className="hero-stat">
              <div className="stat-num text-gradient-luxe">{stat.value}</div>
              <div className="stat-lbl">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="hero-scroll-hint">
        <span>Scroll</span>
        <div className="scroll-line" />
      </div>
    </section>
  );
}

export default Hero;
